export default __webpack_public_path__ + "static/media/logo.1c821c72.png";